module.exports = __webpack_public_path__ + "static/media/Discover.d6bf94d9.svg";